import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { combineValues } from '@clds/component-theme';
import { Icon, iconMixin } from '@cld/icon';
import { ICON_SIZES, STATES } from '../../constants';
import { styleByState } from '../../helpers';
import { wizardTheme } from '../../theme';

const getSharedIconStyle = (stateName) => css`
  background-color: ${wizardTheme.step.background.color[stateName]};
  color: ${wizardTheme.step.font.color[stateName]};
  ${Icon} {
    ${(props) => iconMixin({ ...props, size: 'sm' })}
  }
`;

const iconStyle = styleByState({
  [STATES.DISABLED]: getSharedIconStyle('disabled'),
  [STATES.ERROR]: getSharedIconStyle('error'),
  [STATES.COMPLETED]: getSharedIconStyle('completed'),
  [STATES.INCOMPLETE]: getSharedIconStyle('incomplete'),
  [STATES.ACTIVE]: css`
    ${getSharedIconStyle('active')};
    width: ${ICON_SIZES.ACTIVE}px;
    height: ${ICON_SIZES.ACTIVE}px;
    background-color: ${combineValues(wizardTheme.step.background.color.active, (color) => rgba(color, 0.06))};
    border: 2px solid ${wizardTheme.step.background.color.active};

    ${Icon} {
      ${(props) => iconMixin({ ...props, size: 'md' })}
    }
  `,
});

const StepIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${ICON_SIZES.OTHER}px;
  height: ${ICON_SIZES.OTHER}px;
  overflow: hidden;
  border-radius: ${wizardTheme.step.border.radius};
  border: 2px solid transparent;
  transition: all 0.2s ease-in-out;
  ${iconStyle}
`;

export default StepIcon;
